import React, { useLayoutEffect } from 'react';
import getBreakpointFlags from '../../helpers/get-breakpoint-flags';
import isSafari from '../../helpers/isSafari';
import useWindowSize from '../../hooks/useWindowSize';
import styles from './pdf-display.module.scss';

const PdfDisplay = (props: any) => {
  const { data } = props;
  const { title, src } = data || {};
  const { width } = useWindowSize();
  const { isMobile } = getBreakpointFlags(width);

  useLayoutEffect(() => {
    if (src && isSafari() && isMobile) window.location.replace(src);
  }, [isSafari, isMobile, src]);

  return (
    title &&
    src && (
      <iframe
        className={styles['pdf-display']}
        title={title}
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        width="100%"
        height="100%"
        scrolling="auto"
        src={src}
      />
    )
  );
};

export default PdfDisplay;
